import IconExperiences from '../components/Icons/IconExperiences';
import IconFarmToForkDining from '../components/Icons/IconFarmToForkDining';
import IconLocalProducers from '../components/Icons/IconLocalProducers';
import IconMarketsAndEvents from '../components/Icons/IconMarketsAndEvents';
import IconPlacesToStay from '../components/Icons/IconPlacesToStay';
import IconShopsAndDeliveryBoxes from '../components/Icons/IconShopsAndDeliveryBoxes';

const LOCAL_PRODUCERS = 'local-producers';
const SHOP_AND_DELIVERY_BOXES = 'shop-and-delivery-boxes';
const MARKETS_EVENTS = 'markets_events';
const PRODUCERS_PLACES = 'producers-places';
const FARM_TO_FORK_DINING = 'farm-to-fork-dining';
export const EXPERIENCES = 'experiences';

export const categoryIcons = {
  [LOCAL_PRODUCERS]: <IconLocalProducers />,
  [SHOP_AND_DELIVERY_BOXES]: <IconShopsAndDeliveryBoxes />,
  [MARKETS_EVENTS]: <IconMarketsAndEvents />,
  [PRODUCERS_PLACES]: <IconPlacesToStay />,
  [FARM_TO_FORK_DINING]: <IconFarmToForkDining />,
  [EXPERIENCES]: <IconExperiences/>
};

export const subcategoryFields = {
  [LOCAL_PRODUCERS]: ['producer_type_category'],
  [SHOP_AND_DELIVERY_BOXES]: ['type'],
  [MARKETS_EVENTS]: ['markets_events'],
  [PRODUCERS_PLACES]: ['producers_places', 'features'],
  [FARM_TO_FORK_DINING]: ['placetype', 'farm_to_fork_dining_features'],
  [EXPERIENCES]: ['experience_type']
};

export const primaryFiltersInModal = [
  'pub_categoryLevel1',
  'pub_producer_type_category',
  'pub_type',
  'pub_markets_events',
  'pub_producers_places',
  'pub_features',
  'pub_placetype',
  'pub_farm_to_fork_dining_features',
  'keywords'
];